// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from './api/axios'
import './assets/css/main.css'
import './assets/css/quill.snow.css'
import './assets/css/daping.css'
import VueQuillEditor from 'vue-quill-editor'
import api from "./api/index.js" 
import mavonEditor from 'mavon-editor'
Vue.use(mavonEditor)
import 'mavon-editor/dist/css/index.css'
import '../static/font/font.css'
// import wx from 'weixin-js-sdk'
// Vue.prototype.$wx = wx
Vue.config.productionTip = false;
Vue.prototype.$api = api
Vue.use(ElementUI);
Vue.use(axios)
// Vue.use(wx)
import htmlToPdf from './api/jspdf'
Vue.use(htmlToPdf)
Vue.prototype.$bus = new Vue()
Vue.prototype.$fonsize = function(res) {

  let docEl = document.documentElement,

    clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  if (!clientWidth) return;

  let fontSize = 100 * (clientWidth / 1620);

  return res * fontSize;

}
// use
Vue.use(VueQuillEditor)
router.afterEach((to,from,next) => {
  window.scrollTo(0,0); 
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js